import { render } from "./Datenschutz.vue?vue&type=template&id=5c2dda2c&scoped=true"
import script from "./Datenschutz.vue?vue&type=script&lang=js"
export * from "./Datenschutz.vue?vue&type=script&lang=js"

import "./Datenschutz.vue?vue&type=style&index=0&id=5c2dda2c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2dda2c"]])

export default __exports__